export enum Direction {
  up = 'up',
  down = 'down'
}
